import styled from "styled-components";

export const Styled = styled.div`
  & {
    height: 100%;
    .docx-wrapper {
      padding: 0;
    }
  }
`;
